export default __webpack_public_path__ + "assets/webgl/complete-22.06493a70.jpg";